---
title: ecosystem.Ai pre-pivot platform
slug: ecosystem-pre-pivot
type: work
status: published
featured: false
summary: The earlier ecosystem.Ai engine — graphs of companies, people, and investors, a company timeline, and a prediction server — before the current runtime.
sitePublishedAt: "2026-10-02"
originalPublishedAt: "2016-08-21"
lastReviewedAt: "2026-10-02"
audiences:
  - business
themes:
  - network-analysis
  - platform-architecture
  - prediction-in-production
sourceUrl: https://jayvanzyl.me/projects/ecosystemai/
originalAuthor: Jay van Zyl
sourceRelationship: first-party archive of the earlier product
rightsStatus: first-party
seoDescription: The earlier ecosystem.Ai platform — business ecosystem graphs, company timelines, the prediction server, and the 2018 architecture.
canonicalPath: /work/ecosystem-pre-pivot
---

import { BusinessEcosystemsGallery, PredictionServerGallery, ProductArchitectureFigure } from "@/features/work/EcosystemPrePivotGallery"

This is the platform before the current prediction runtime. The offer at the time was:

> We analyze and predict how human and business ecosystems behave during times of change. Our intelligent and predictive approach uses the ecosystem/AI Engine to extract hidden value in complex data. Making decisions about market positioning, product and service portfolios, customer segments, and a number of key strategic questions can be answered by using our Engine.

The engagement was a hands-on cycle of ecosystem analysis. Recommendations were meant to shape a place in a competitive market. The current platform is the [ecosystem.Ai case](/work/ecosystem-ai). The product site is [ecosystem.ai](https://ecosystem.ai).

### Business ecosystems

The 2016 workbench was an explorer for an AI ecosystem. The AI 2016 Ecosystem file held 451 items, generated 9 October 2016. Graph views covered people, past teams, locations, board members, market, investors, and boards. The screenshots are that investor graph, the company timeline from 1990, and a closer funding timeline through 2016.

<BusinessEcosystemsGallery />

### Prediction server

The next surface was a prediction server. A project wizard set up munging and a prediction model. A model wizard offered Deep Learning, Distributed Random Forest, Gradient Boosted Machine, Generalized Linear Modeling, Naive Bayes, XGBoost, K-Means, and Word2Vec. The server API, under Apache 2.0, stored and retrieved models, predictions, and prediction projects.

<PredictionServerGallery />

### Product architecture

A 2018 drawing of the same idea as a product architecture. Client Pulse Responder, Ecogenetic, and the block labeled Commemity sit on the ecosystem.Ai server and the runtime engine. Under those are the cloud workers: Google, Microsoft, AWS, IBM Watson, and H2O.

<ProductArchitectureFigure />
